import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import {
  BLANK_OPTION,
  mapCurrency,
} from '../../../common/order/popup/popupConfirmationBuyNowOrAddCart/constants'
import { SelectCustom } from '../../../common/selectCustom'
import TextEllipsis from '../../../common/textEllipsis'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'
import { Z_INDEX } from '../../../utils/common'
import { CURRENCY, CURRENCY_UNIT, UNIT } from '../../../utils/currency'
import { LANGUAGE_SELECT } from '../../constant'
import { changeDefaultFormFactSheet } from '../../store/slice'

export const SubCriteriaFactSheet = ({
  language,
  currency,
  unit,
  currencyFS,
  unitFS,
}) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const refSelect = useRef()

  const [width, setWidth] = useState(0)

  const additionalCurrencyOptions = [
    BLANK_OPTION,
    mapCurrency.USD,
    mapCurrency.EUR,
  ].filter((item) => item.value !== currency?.value)

  const additionalUnitOptions = (CURRENCY_UNIT[currencyFS?.value] || []).map(
    (unitKey) => ({
      label: UNIT[unitKey]?.label,
      value: UNIT[unitKey]?.multiplier,
      isI18n: true,
    }),
  )

  const changeData = (item, key) => {
    const data = { [key]: item }

    switch (key) {
      case 'currency':
        if (item.value === currencyFS?.value) {
          data.currencyFS = {}
          data.unitFS = {}
        }
        const multipliers = CURRENCY_UNIT[item.value].map(
          (i) => UNIT[i].multiplier,
        )
        if (!multipliers.includes(unit)) {
          data.unit = { value: UNIT.SINGLE.multiplier }
        }
        break
      case 'currencyFS':
        const isBlank = item.value === BLANK_OPTION.value
        data.currencyFS = isBlank ? {} : item
        if (isBlank) data.unitFS = {}
        if (!currencyFS?.value && !isBlank) {
          data.unitFS = { value: UNIT.SINGLE.multiplier }
        }
        break
      default:
        break
    }

    dispatch(changeDefaultFormFactSheet(data))
  }

  useEffect(() => {
    if (refSelect?.current) {
      setWidth(refSelect.current.clientWidth)
    }
  }, [])

  return (
    <Element
      className="flexColumn gap2 pt1 fw600"
      style={{
        padding: 12,
        paddingLeft: 20,
        marginTop: [USER_TYPE.LITE, USER_TYPE.BASIC].includes(
          userType.userTypeId,
        )
          ? 12
          : 0,
        marginLeft: [USER_TYPE.LITE, USER_TYPE.BASIC].includes(
          userType.userTypeId,
        )
          ? 20
          : 0,
        backgroundColor: '#FFFFFF',
      }}
    >
      <div className="dFlex" style={{ gap: 20 }}>
        <div
          className="dFlex justifyContentBetween alignItemsCenter"
          style={{ width }}
        >
          <div>
            <Translate value="cartAndOrders.main.language" />:
          </div>
          <SelectCustom
            zIndex={Z_INDEX.MODAL + 1}
            activeItem={language}
            data={LANGUAGE_SELECT}
            className="fw400"
            style={{ minWidth: 120, borderColor: '#B5B5B5' }}
            isI18n
            chooseItem={(value) => changeData(value, 'language')}
          />
        </div>
        <div style={{ width: 1, backgroundColor: 'transparent' }} />
        <div className="w35"></div>
      </div>
      <div className="dFlex" style={{ gap: 20 }}>
        <div>
          <div
            className="w100 dFlex justifyContentBetween alignItemsCenter"
            style={{ width }}
          >
            <div>
              <Translate value="cartAndOrders.main.currency" />:
            </div>
            <SelectCustom
              className="fw400"
              zIndex={Z_INDEX.MODAL + 1}
              activeItem={currency}
              data={Object.values(CURRENCY).map((i) => ({
                label: i,
                value: i,
              }))}
              style={{ minWidth: 120, borderColor: '#B5B5B5' }}
              chooseItem={(value) => changeData(value, 'currency')}
            />
          </div>
        </div>
        <div style={{ width: 1, backgroundColor: '#9C9C9C' }} />
        <div className="w20">
          <div className="w100 dFlex justifyContentBetween alignItemsCenter">
            <div>
              <Translate value="cartAndOrders.main.unit" />:
            </div>
            <SelectCustom
              className="fw400"
              zIndex={Z_INDEX.MODAL + 1}
              activeItem={unit}
              style={{ minWidth: 120, borderColor: '#B5B5B5' }}
              data={CURRENCY_UNIT[currency.value].map((unitKey) => ({
                label: UNIT[unitKey].label,
                value: UNIT[unitKey].multiplier,
                isI18n: true,
              }))}
              isI18n
              chooseItem={(value) => changeData(value, 'unit')}
            />
          </div>
        </div>
      </div>
      <div className="dFlex" style={{ gap: 20 }}>
        <div ref={refSelect}>
          <div className="w100 dFlex justifyContentBetween alignItemsCenter gap2">
            <div>
              <Translate value="cartAndOrders.main.additional" />:
            </div>
            <SelectCustom
              className="fw400"
              zIndex={Z_INDEX.MODAL + 1}
              activeItem={currencyFS}
              data={additionalCurrencyOptions}
              style={{ minWidth: 120, borderColor: '#B5B5B5' }}
              isI18n
              chooseItem={(value) => changeData(value, 'currencyFS')}
              renderActiveItem={(activeItem) => (
                <TextEllipsis
                  text={
                    activeItem.value === BLANK_OPTION.value
                      ? ' '
                      : activeItem.label
                  }
                  isI18n
                  zIndexTooltip={Z_INDEX.MODAL + 1}
                />
              )}
            />
          </div>
        </div>
        <div style={{ width: 1, backgroundColor: '#9C9C9C' }} />
        <div className="w20">
          <div className="w100 dFlex justifyContentBetween alignItemsCenter">
            <div>
              <Translate value="cartAndOrders.main.unit" />:
            </div>
            <SelectCustom
              className="fw400"
              zIndex={Z_INDEX.MODAL + 1}
              activeItem={unitFS}
              style={{ minWidth: 120, borderColor: '#B5B5B5' }}
              data={additionalUnitOptions}
              isI18n
              chooseItem={(value) => changeData(value, 'unitFS')}
              disabled={!additionalUnitOptions.length}
            />
          </div>
        </div>
      </div>
    </Element>
  )
}
